import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import styled, { css } from 'styled-components';
import { marginAttributes, propsBlocker, getComponentOverride, widthAttributes, reset, typography, color, spacing, borderRadius } from '../../../system';

var getRootStyle = function getRootStyle(_ref) {
  var primaryIconBackgroundColor = _ref.primaryIconBackgroundColor,
      disabled = _ref.disabled;
  var result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n         {\n            background-color: ", ";\n        }\n    "])), primaryIconBackgroundColor);

  if (disabled) {
    result = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            background-color: ", ";\n            color: ", ";\n        "])), color('neutral.02'), color('neutral.04'));
  }

  return result;
};

export var PrimaryIconWrapperRoot = styled.div.withConfig(propsBlocker)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-self: center;\n    align-items: center;\n    border-radius: ", ";\n    height: ", ";\n    width: ", ";\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), reset, typography('paragraphMedium'), borderRadius('round'), spacing(11), spacing(11), getRootStyle, getComponentOverride('PrimaryIconWrapper'), marginAttributes, widthAttributes);